import { enGBLocale } from '@/constants';
import { Box } from '@material-ui/core';
import { DesktopDateRangePicker, LocalizationProvider } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { TextField } from '@mui/material';
import { isValid } from 'date-fns';
import useStyles from './styles';
import { RangeDatePickerProps } from './types';

export default function RangeDatePicker({
  date,
  setDate,
  ...rest
}: RangeDatePickerProps): JSX.Element {
  const classes = useStyles();

  return (
    <LocalizationProvider locale={enGBLocale} dateAdapter={AdapterDateFns}>
      <DesktopDateRangePicker<Date | null>
        {...rest}
        PopperProps={{
          ...(rest.PopperProps && { ...rest.PopperProps }),
          className: classes.popper,
        }}
        className={classes.paperContent}
        value={date}
        onChange={(dateRange) => {
          if (dateRange.some((item) => !isValid(item))) {
            return;
          }
          setDate(dateRange);
        }}
        inputFormat="dd.MM.yyyy"
        mask="__.__.____"
        startText="Start"
        renderInput={(startProps, endProps) => (
          <>
            <TextField {...startProps} className={classes.dateTextField} />
            <Box sx={{ mx: 2 }}> to </Box>
            <TextField {...endProps} className={classes.dateTextField} />
          </>
        )}
      />
    </LocalizationProvider>
  );
}
